module.exports = __webpack_public_path__ + "img/she.c01834ba.png";